module.exports = __webpack_public_path__ + "img/whatsapp.e13eac20.svg";